import { Flex } from "@braze/beacon-core";
import React from "react";
import styled from "styled-components";

type ButtonContainerProps = {
  style?: React.CSSProperties;
  children: React.ReactNode;
};

export const RoundedCard = ({style, children}: ButtonContainerProps) => {
  return <Container style={style}>{children}</Container>;
}

const Container = styled(Flex)`
  padding: 2em 4em;
  margin: 3em;
  background: #fff;
  border-radius: 1.5em;
  border: 1px solid rgba(0, 0, 0, 0.05);
  flex-direction: column;
`;